module.exports = __webpack_public_path__ + "media/images/new/icons/mo_mo-e1232033c1dddf336c435ad7a0d67aae.png";